import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './lang-en.json';
import ja from './lang-ja.json';
import fr from './lang-fr.json';
import it from './lang-it.json';
import de from './lang-de.json';
import pt from './lang-pt.json';

i18n
.use(initReactI18next)
.init({
	resources: {
		en: { translation: en },
		ja: { translation: ja },
		fr: { translation: fr },
		it: { translation: it },
		de: { translation: de },
		pt: { translation: pt },
	},
	lng: localStorage.getItem("MTGDeck/Local/Language") || "ja",
	fallbackLng: 'en',
	react: {
		useSuspense: false,
	},
	interpolation: {
		escapeValue: false,
	},
});

i18n.on("languageChanged", (lng) => {
	localStorage.setItem("MTGDeck/Local/Language", lng)
});

export default i18n;
